import {AssetType} from '@hconnect/common/types'
import {
  KilnRotaryIcon as RotaryKilnIcon,
  MillCementIcon as CementMillIcon,
  MillRawIcon as RawMillIcon,
  OtherAssetsIcon
} from '@hconnect/uikit/src/common'
import React from 'react'

export const assetIconMap: Record<AssetType, React.ReactNode> = {
  [AssetType.CementMill]: <CementMillIcon style={{fill: 'inherit'}} />,
  [AssetType.RawMill]: <RawMillIcon style={{fill: 'inherit'}} />,
  [AssetType.RotaryKiln]: <RotaryKilnIcon style={{fill: 'inherit'}} />,
  [AssetType.Other]: <OtherAssetsIcon style={{fill: 'inherit'}} />,
  [AssetType.Crusher]: <OtherAssetsIcon style={{fill: 'inherit'}} />,
  [AssetType.CoalMill]: <></>,
  [AssetType.BaseLoad]: <></>
}
